<template>
    <div class="d-flex flex-column">
        <div class="title-item">{{ $t('fixedRentalSettings.title') }}</div>
        <div class="d-flex flex-column flex-md-row">
            <div class="col p-0">
                <div class="title-lable" style="width: 15rem">
                    <span class="ml-3">{{ $t('fixedRentalSettings.rentalPeriod') }}</span>
                </div>
                <div class="d-flex flex-row align-items-center mt-3 ml-3">
                    <div>
                        <el-input-number
                            @change="periodChange"
                            size="small"
                            v-model="request.periodUnit"
                            :min="1"
                            :max="100"
                        >
                        </el-input-number>
                    </div>
                    <div class="ml-5">
                        <el-select
                            @change="periodChange"
                            style="width: 7.5rem"
                            size="small"
                            v-model="request.period"
                            :placeholder="$t('createImage.selectPlaceholder')"
                        >
                            <el-option
                                v-for="item in listPeriod"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div v-if="request.isShowNumberMachine" class="col p-0">
                <div class="title-lable" style="width: 15rem">
                    <span class="ml-3">{{ $t('fixedRentalSettings.numberOfMachine') }}</span>
                </div>
                <div class="d-flex flex-row align-items-center mt-3 ml-3">
                    <div>
                        <el-input-number
                            @change="calculateTotalCost"
                            size="small"
                            v-model="request.numberMachine"
                            :min="1"
                            :max="100"
                        ></el-input-number>
                    </div>
                </div>
            </div>
            <div class="col p-0 mt-5 mt-md-0">
                <div class="title-lable" style="width: 15rem">
                    <span class="ml-3">{{ $t('fixedRentalSettings.totalCost') }}</span>
                </div>
                <div class="d-flex flex-row align-items-center mt-3 ml-3">
                    <div
                        class="d-flex justify-content-center align-items-center"
                        v-if="totalCost"
                    >
                        <del
                            v-if="totalCostByHour !== totalCost"
                            class="d-flex flex-row align-items-center"
                            style="color: red; opacity: 0.5"
                        >
                            <div style="color: #42a5f5; font-size: 1.3rem">
                                {{ totalCostByHour.toLocaleString() }}
                            </div>
                            <div class="d-flex flex-row align-items-center">
                                <img
                                    class="ml-2"
                                    src="/logo/logo-irender-coin.svg"
                                    width="13"
                                    height="13"
                                />
                            </div>
                        </del>
                        <div class="d-flex flex-row align-items-center ml-3">
                            <div style="color: #42a5f5; font-size: 1.3rem">
                                {{ totalCost.toLocaleString() }}
                            </div>
                            <div class="d-flex flex-row align-items-center">
                                <img
                                    class="ml-2"
                                    src="/logo/logo-irender-coin.svg"
                                    width="13"
                                    height="13"
                                />
                            </div>
                        </div>
                    </div>
                    <div v-else style="opacity: 0.5">-- -- --</div>
                </div>
            </div>
        </div>
        <div class="mt-5 ml-3" style="font-size: 0.85rem">
            <span>{{ $t('fixedRentalSettings.rentingTimeStarts') }}</span>
            <span
                v-if="!check_status"
                class="ml-2"
                style="font-weight: 600; font-size: 0.95rem; font-style: italic"
                >{{ $t('fixedRentalSettings.now') }}</span
            >
            <span
                v-else
                class="ml-2"
                style="font-weight: 600; font-size: 0.95rem; font-style: italic"
                >{{ element[0].endDate | dateFullPrety }}</span
            >
            <span class="ml-2">{{ $t('fixedRentalSettings.andEndsAt') }}</span>
            <span
                v-if="check_status"
                class="ml-2"
                style="
                    font-weight: 600;
                    font-size: 0.95rem;
                    font-style: italic;
                    color: darkorange;
                "
                >{{ endTime | dateFullPrety }}</span
            >
            <span
                v-else
                class="ml-2"
                style="
                    font-weight: 600;
                    font-size: 0.95rem;
                    font-style: italic;
                    color: darkorange;
                "
                >{{ endTime | dateFullPrety }}</span
            >
        </div>
    </div>
</template>

<script>
import moment from "moment";

// Extend
import base from "@/scripts/base";

// Constant
import {
    PRICE_PROPERTIES_NAME,
    ELEMENT_LIST_PERIOD,
    ELEMENT_LIST_PERIOD_ON_CREATED,
    PERIOD_TO_HOUR,
} from "@/constant/fixedRental";
import { PERIOD } from "../../../constant/fixedRental";

export default {
    extends: base,

    props: {
        element: {
            type: Array,
            default() {
                return [];
            },
        },
        request: {
            type: Object,
            default: null,
        },
        isOnCreated: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            packagesFixed1Hours: ["30"],

            totalCostByHour: null,
            totalCost: null,

            endTime: null,

            check_status: null,
        };
    },

    computed: {
        targetImage() {
            return this.element[0]
        },
        ELEMENT_LIST_PERIOD_LIST() {
            return this.isOnCreated ? (process.env.VUE_APP_CODE === 'IRENDER_GPU_VN' ? ELEMENT_LIST_PERIOD_ON_CREATED(this.targetImage.packageId) : ELEMENT_LIST_PERIOD) : ELEMENT_LIST_PERIOD;
        },
        listPeriod() {
            return this.isOnCreated ? (process.env.VUE_APP_CODE === 'IRENDER_GPU_VN' ? ELEMENT_LIST_PERIOD_ON_CREATED(this.targetImage.packageId) : ELEMENT_LIST_PERIOD) : ELEMENT_LIST_PERIOD;
        }
    },

    watch: {
        element: function (value) {
            this.initListPeriod(value);
            this.$nextTick(() => {
                this.periodChange();
            });
        },
    },

    mounted() {
        this.initListPeriod(this.element);

        this.request.period = this.listPeriod[0].value;

        this.$nextTick(() => {
            this.periodChange();
        });
    },

    methods: {
        initListPeriod(value) {
            // if (value[0].packageId === undefined) {
            //     if (
            //         !this.packagesFixed1Hours.includes(value[0].id.toString())
            //     ) {
            //         this.listPeriod = this.ELEMENT_LIST_PERIOD_LIST.slice(1);
            //     } else {
            //         this.listPeriod = this.ELEMENT_LIST_PERIOD_LIST;
            //     }

            //     this.request.period = this.listPeriod[0].value;
            // } else {
            //     if (
            //         !this.packagesFixed1Hours.includes(
            //             value[0].packageId.toString()
            //         )
            //     ) {
            //         this.listPeriod = this.ELEMENT_LIST_PERIOD_LIST.slice(1);
            //     } else {
            //         this.listPeriod = this.ELEMENT_LIST_PERIOD_LIST;
            //     }
            // }
        },
        //#region Period change
        periodChange() {
            this.calculateTotalCost();
            this.calculateEndTime();
            this.$emit("processingEvent", { event: "periodChange" });
        },
        //#endregion

        //#region Calculate total cost
        calculateTotalCost() {
            if (this.element) {
                this.totalCost = 0;
                this.totalCostByHour = 0;

                this.element.forEach((element) => {
                    this.totalCost +=
                        element[PRICE_PROPERTIES_NAME[this.request.period]];
                });
                this.totalCost =
                    this.totalCost *
                    this.request.periodUnit *
                    (this.request.isShowNumberMachine
                        ? this.request.numberMachine
                        : 1);

                this.element.forEach((element) => {
                    this.totalCostByHour += element.priceHour;
                });
                this.totalCostByHour =
                    this.totalCostByHour *
                    this.request.periodUnit *
                    (this.request.isShowNumberMachine
                        ? this.request.numberMachine
                        : 1) *
                    PERIOD_TO_HOUR[this.request.period];
            } else {
                this.totalCost = null;
                this.totalCostByHour = null;
            }
            this.request.totalCost = this.totalCost;
            this.request.totalCostByHour = this.totalCostByHour;
        },
        //#endregion

        calculateEndTime() {
            let endTime = null;
            let endDate = null;

            if (
                this.element &&
                this.element[0].fixedRental == true &&
                this.element[0].fixedRentalTimeRemaining !== "Expired !"
            ) {
                this.check_status = true;
                endDate = this.element[0].endDate;
            }
            switch (this.request.period) {
                case PERIOD.HOUR:
                    if (this.check_status) {
                        endTime = moment.utc(endDate).local().add(
                            1 * this.request.periodUnit,
                            "hours"
                        );
                    } else {
                        endTime = moment().add(
                            1 * this.request.periodUnit,
                            "hours"
                        );
                    }
                    break;
                    
                case PERIOD.THREE_HOUR:
                    if (this.check_status) {
                        endTime = moment.utc(endDate).local().add(
                            3 * this.request.periodUnit,
                            "hours"
                        );
                    } else {
                        endTime = moment().add(
                            3 * this.request.periodUnit,
                            "hours"
                        );
                    }
                    break;

                case PERIOD.SIX_HOUR:
                    if (this.check_status) {
                        endTime = moment.utc(endDate).local().add(
                            6 * this.request.periodUnit,
                            "hours"
                        );
                    } else {
                        endTime = moment().add(
                            6 * this.request.periodUnit,
                            "hours"
                        );
                    }
                    break;

                case PERIOD.DAY:
                    if (this.check_status) {
                        endTime = moment.utc(endDate).local().add(
                            this.request.periodUnit,
                            "d"
                        );
                    } else {
                        endTime = moment().add(this.request.periodUnit, "d");
                    }
                    break;

                case PERIOD.WEEK:
                    if (this.check_status) {
                        endTime = moment.utc(endDate).local().add(
                            7 * this.request.periodUnit,
                            "d"
                        );
                    } else {
                        endTime = moment().add(
                            7 * this.request.periodUnit,
                            "d"
                        );
                    }
                    break;

                case PERIOD.MONTH:
                    if (this.check_status) {
                        endTime = moment.utc(endDate).local().add(
                            30 * this.request.periodUnit,
                            "d"
                        );
                    } else {
                        endTime = moment().add(
                            30 * this.request.periodUnit,
                            "d"
                        );
                    }
                    break;

                default:
                    break;
            }

            this.endTime = moment(endTime);
        },
    },
};
</script>
